import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Header from './Header'
import { usesAppChrome } from '../../lib/appChrome'
import { attachSpaLinkInterceptor } from '../../lib/spaNavigation'

export default function AppLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const isHome = location.pathname === '/'
  const usesPageHeader = usesAppChrome(location.pathname)

  useEffect(() => attachSpaLinkInterceptor(navigate), [navigate])

  if (isHome) {
    return <Outlet />
  }

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      {!usesPageHeader && <Header />}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
